import type { SVGProps } from "react";

export default function TripleDotsIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg fill="none" width="20" height="20" viewBox="0 0 24 24" {...props}>
      <circle cx="5" cy="12" r="2" fill="currentColor" />
      <circle cx="12" cy="12" r="2" fill="currentColor" />
      <circle cx="19" cy="12" r="2" fill="currentColor" />
    </svg>
  );
}
